export default "__VITE_ASSET__Deea5OtW__"